import { Component, Input, ViewChild, EventEmitter, ChangeDetectorRef, OnInit } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';
import { App, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { CategoriesProvider } from '../../../../providers/categories/categories';
import { ConfigProvider } from '../../../../providers/config/config';
import { EventDetailsModel, EventProvider, } from '../../../../providers/event/event';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { MyPicsListModel, UserProvider } from '../../../../providers/user/user';
import { PictureViewerPage } from '../../../picture-viewer/picture-viewer';
import { EventDetailsMapPage } from '../event-details-map/event-details-map';
import { NearbyMapPage } from '../../../nearby/main/nearby-main';
import { NearbyMainResolver } from '../../../nearby/main/nearby-main-resolver';
import { ResultProvider, RanglistSearchModelByID } from '../../../../providers/result/result';
import { SessionProvider } from '../../../../providers/session/session';
import { TransDatePipe } from '../../../../pipes/trans-date/trans-date';
import { ResultAddPage } from '../../../results/result-add/result-add';
import { StrackerProvider, TrackerModel } from '../../../../providers/stracker/stracker';
import { GpsTracker } from '../../../../tracker/gps-tracker';
import { GlobalUtil } from '../../../../tracker/global-utils';
import { StrackerPage } from '../../../../tracker/sencha-tracker/stracker';
import { EventDetailsProvider } from '../../../../providers/event-details/event-details';
import { StorageProvider } from '../../../../providers/storage-service/storage-service';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { SettingsProvider } from '../../../../providers/settings/settings';

@Component({
  selector: 'page-event-details-shop',
  templateUrl: 'event-details-shop.html'
})
export class EventDetailsShopPage implements OnInit {
  @Input('event') event: any;
  @Input('dateFormatted') dateFormatted: string;
  @Input('event-tabs-instance') parentInstance: any;

  routes: any[] = [];
  filteredImages: MyPicsListModel[] = [];
  options: string[] = [];
  client: {
    arrowPressed: boolean
  } = {
      arrowPressed: false
    };

  titleImage: MyPicsListModel;

  isVirtual: boolean = false; // indicates whether the event is virual or not

  //
  clientSponsor: boolean = false; // sponsor app displays tracker button
  clientLauftreff: boolean = false; // lauftreff app displays button and combobox instead of 'GPS Tracking' and 'Event merken'
  clientEvents: boolean = false; // if it's false then show live results
  clientHannover: boolean = false;
  clientHella: boolean = false;
  //

  @ViewChild('myPlaceholder')
  myPlaceholder: any;

  @ViewChild('uploadButton')
  uploadButton: any;

  startDisabled: boolean = false;
  liveDisabled: boolean = false;

  showMark: boolean = false;

  //UI
  isNullStartDate: boolean = false;
  clientApp: boolean = false;
  isBrowser: boolean = false;

  paymentDetails = {
    price: 0,
    formattedPrice: "",
    imageUrl: "",
    contents: "",
    additionalFeatures: [{
      title: "",
      contents: "",
      price: 0,
      currency: "",
      imageUrl: "",

      mandatory: false,
      shippingTypes: [{
        shippingPrice: 0,
        country: "",
        formattedPrice: ""
      }]
    }]
  }

  shippingRadio: any;
  totalPrice: number = 0;
  nextAvailable: boolean = false;
  pipeDateFormat = "dd.MM.yyyy";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private eventService: EventProvider,
    private categoryService: CategoriesProvider,
    private app: App,
    private camera: Camera,
    private loadingCtrl: LoaderProvider,
    private iab: InAppBrowser,
    private toastCtrl: ToastController,
    private config: ConfigProvider,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    private nearbyMainResolver: NearbyMainResolver,
    private changeDetector: ChangeDetectorRef,
    private resultService: ResultProvider,
    private sessionService: SessionProvider,
    private transDate: TransDatePipe,
    private strackerService: StrackerProvider,
    private userService: UserProvider,
    private settingsService: SettingsProvider,
    private storageService: StorageProvider,
    private appDetector: AppDetectorProvider,
    private inAppBrowser: InAppBrowser) {
    new Promise(async (resolve, reject) => {
      this.settingsService.getActiveDateFormat().then(date => {
        this.pipeDateFormat = date.pipeFormat;
      });
      this.clientSponsor = (await this.config.config).showHide.trackerButton;
      this.clientLauftreff = (await this.config.config).showHide.lauftreff;
      this.clientHannover = (await this.config.config).appId.includes("hannover") ? true : false;
      this.clientHella = (await this.config.config).appId.includes("hella") ? true : false;
      this.clientEvents = (await this.config.config).appId.includes("events") ? true : false;

      let name: string = (await this.config.config).appId;
      this.isBrowser = (await this.config.config).platform.browser;

      let eventDate;
      let initData = new Date(this.event.date);

      if (!this.event.endDate || this.event.endDate === 'undefined' || this.event.endDate == 0) {
        eventDate = new Date(this.event.date);

      } else {
        eventDate = new Date(this.event.endDate);
      }
      // console.log('eventDate: ', eventDate);
      let finalDate = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate() + 2, 3);
      console.log('finalDate: ', finalDate);
      let startDate = new Date(initData.getFullYear(), initData.getMonth(), initData.getDate(), 0, 1);
      console.log('startDate: ', startDate);

      this.startDisabled = ((finalDate.getTime() - new Date().getTime()) < 0) ? true : false;
      this.liveDisabled = ((startDate.getTime() - new Date().getTime()) < 0) ? false : true;

      this.clientApp = name.includes("hella") || name.includes("hannover") || name.includes("vivawest") || name.includes("thurnau");

      GlobalUtil.getInstance().currentEventID = this.event.id;
      console.log('GpsTracker.currentEventID: ', GlobalUtil.getInstance().currentEventID);

      if (this.event.name.length < 1) {
        this.eventService.getEventDetails(this.event.id).then((event: EventDetailsModel) => {
          this.event = event;
          this.isVirtual = (this.event.eventType.toUpperCase().includes("V") || this.event.eventType.toUpperCase().includes("S"));
        });
      } else {
        this.isVirtual = (this.event.eventType.toUpperCase().includes("V") || this.event.eventType.toUpperCase().includes("S"));
      }

      this.checkForStartDate();
      this.dummyInitialize();
      resolve(null);
    });
  }

  ngOnInit() {
    let lang = this.translate.getDefaultLang();
    this.eventService.getPaymentDetails(this.event.id, lang).then(paymentDetails => {
      this.paymentDetails = paymentDetails;
      this.totalPrice = this.paymentDetails.price;
      for (let i = 0; i < this.paymentDetails.additionalFeatures.length; i++) {
        this.totalPrice += (this.paymentDetails.additionalFeatures[i].mandatory) ? this.paymentDetails.additionalFeatures[i].price : 0;
      }
      this.parentInstance.totalPrice = this.totalPrice;
      this.parentInstance.currency = (lang.includes("de")) ? "EUR" : "USD";
      let element = document.getElementById('external-html');
      element.innerHTML = this.paymentDetails.contents;
      console.log('this.paymentDetails.contents: ', this.paymentDetails.contents);
    });
  }

  onTest() {
    this.sessionService.getToken(false, false).then(token => {
      this.strackerService.getResultPreload(this.event.id, this.sessionService.profile.id + "").then((data: TrackerModel) => {
        GpsTracker.sumDistance = 0;
        GpsTracker.currentSpeed = "0";

        (this.app.getRootNav() as NavController).push(StrackerPage, { event: this.event, imageLink: "", data: data, token: this.sessionService.profile.id + "" });
      });
    });
  }

  checkForStartDate() {
    this.dateFormatted = this.transDate.transform(this.event.date, "HH:mm");

    if (this.event.eventType.toUpperCase().includes("V") || this.event.eventType.toUpperCase().includes("S")) {
      this.isNullStartDate = true;
      return;
    } else {
      if (this.dateFormatted.includes("00:00"))
        this.isNullStartDate = true;
    }
  }

  shippingSelected(additional, shipping) {
    console.log('shipping: ', shipping);
    this.totalPrice = this.paymentDetails.price + additional.price + shipping.shippingPrice;
    this.parentInstance.totalPrice = this.totalPrice;
    this.nextAvailable = true;
  }

  additionalSelected(additional) {
    this.totalPrice = this.paymentDetails.price + additional.price + additional.shippingTypes[0].shippingPrice;
    this.parentInstance.totalPrice = this.totalPrice;
  }

  calculateTotalPrice() {
    return this.totalPrice;
  }

  nextPage() {
    this.parentInstance.detailPage = "person-information";
  }

  checkForGender() {
    if (this.sessionService.profile) {
      if (this.event.wertung.includes("Männer") && this.sessionService.profile.anrede.includes("Frau")) {
        return false;
      } else if (this.event.wertung.includes("Frauen") && this.sessionService.profile.anrede.includes("Herr")) {
        return false;
      }
    }
    return true;
  }

  getCompetitors() {
    let eventData: RanglistSearchModelByID = { eid: this.event.id, limit: 25, page: 1, start: 0 };

    this.resultService.getRangListById(eventData).then(data => {

      let competitors = data;
      let secondsArr = [];

      for (let i = 0; i < competitors.length; i++) {
        let parts = competitors[i].timeFormatted.split(':');
        secondsArr.push((Number(parts[0]) * 3600 + Number(parts[1]) * 60 + Number(parts[2])) + "");
        competitors[i].timeFormatted = secondsArr[i];
      }

      this.storageService.saveData(competitors, "participants-" + this.event.id).then((data) => {
        console.log("save participants: length = " + competitors.length);
      })
    });
  }

  onOpenResultAddPage(o) {
    this.strackerService.getFastestFinishResult(this.event.id, this.sessionService.profile.id + "").then((data: TrackerModel) => {
      console.log('data: ', data);
      GpsTracker.sumDistance = 0;
      GpsTracker.currentSpeed = "0";
      (this.app.getRootNav() as NavController).push(ResultAddPage, { token: this.sessionService.profile.id + "", imageLink: o.imageLink, event: this.event, data: data });
    });
  }

  onOpenStrackerPage(o) {
    this.strackerService.getResultPreload(this.event.id, this.sessionService.profile.id + "").then(async (data: TrackerModel) => {
      GpsTracker.sumDistance = 0;
      GpsTracker.currentSpeed = "0";

      let route = { hasRoute: false, fullPath: [] }

      if (this.event.eventType ==="R") {
        route.hasRoute = true;
        route.fullPath = Object.assign([], EventDetailsProvider.getInstance().getEventRoute(this.event.id));
      }

      let option = {
        applause: false,
        autoPause: false,
        placement: false,
        google: false
      }

      await this.storageService.checkForExistance('autopause').then((status) => {
        if (status) this.storageService.getSaved('autopause').then((data) => option.autoPause = data);
      });

      await this.storageService.checkForExistance('applause').then((status) => {
        if (status) this.storageService.getSaved('applause').then((data) => option.applause = data);
      });

      await this.storageService.checkForExistance('placement').then((status) => {
        if (status) this.storageService.getSaved('placement').then((data) => option.placement = data);
      });

      await this.storageService.checkForExistance('google').then((status) => {
        if (status) this.storageService.getSaved('google').then((data) => option.google = data);
      });

      console.log('route: ', route);

      (this.app.getRootNav() as NavController).push(StrackerPage, { event: this.event, imageLink: o, data: data, token: this.sessionService.profile.id + "", route: route, option: option });
    });
  }

  async ngAfterViewInit() {
    this.createFileInput();
    this.showMark = (await this.config.config).showHide.eventMark;
    console.log(this.event);
  }

  test() {
    console.log(this.myPlaceholder);
    this.client.arrowPressed = !this.client.arrowPressed;
    this.myPlaceholder.value = (this.client.arrowPressed) ? "pünktlich" : "";
  }

  openTracking() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loading.present();
    this.nearbyMainResolver.doResolve([this.event]).then(data => {
      console.log('data: ', data);
      (this.app.getRootNav() as NavController).push(NearbyMapPage, { events: data }).then(() => loading.dismiss());
    });
  }

  initImages() {
    this.titleImage = this.event.images[0];
    this.filteredImages = this.event.images.slice(1, 4);
  }

  showAllPhoto() {
    const editEmitter = new EventEmitter();
    const deleteEmitter = new EventEmitter();
    editEmitter.subscribe((data) => console.log(data));
    deleteEmitter.subscribe((data) => console.log(data));
    const photoModal = this.modalCtrl.create(PictureViewerPage, {
      emitter: editEmitter,
      emitter1: deleteEmitter,
      pictures: this.event.images,
      activeIndex: 0,
      icon: this.event.isOwner ? 'refresh' : null,
      icon1: this.event.isOwner ? 'trash' : null
    });
    photoModal.present();
    photoModal.onDidDismiss(() => {
      editEmitter.unsubscribe();
      deleteEmitter.unsubscribe();
    });
  }

  showAllPhotoByItem(item) {
    const editEmitter = new EventEmitter();
    const deleteEmitter = new EventEmitter();
    editEmitter.subscribe((data) => this.pictureRotated(data));
    deleteEmitter.subscribe((data) => this.deletePics(data));
    const index = this.event.images.findIndex(x => x.id === item.id);
    const photoModal = this.modalCtrl.create(PictureViewerPage, {
      emitter: editEmitter,
      emitter1: deleteEmitter,
      pictures: this.event.images,
      activeIndex: index,
      icon: this.event.isOwner ? 'refresh' : null,
      icon1: this.event.isOwner ? 'trash' : null
    });
    photoModal.present();
    photoModal.onDidDismiss(() => {
      editEmitter.unsubscribe();
      deleteEmitter.unsubscribe();
    });
  }


  async pictureRotated(event: any) {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    await loader.present();
    let model = event.list[event.index];

    let base64ImageSrc = model.imageLink;
    let that = this;
    let img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');

    img.onload = async () => {
      let c = document.createElement('canvas');
      c.width = img.height;
      c.height = img.width;
      let ctx = c.getContext('2d');
      ctx.rotate((90 * Math.PI) / 180);
      ctx.drawImage(img, 0, -img.height);
      let base = c.toDataURL();
      let that = this;

      console.log('base: ' + base);
      console.log('base.length' + base.length);

      console.log(base.length);
      if (base.length > 6) {
        // let photo = await that.userService.createPhoto(model.id, base);
        // that.userService.removePhoto(model.id);
        // event.list[event.index] = photo;
        // event.list[event.index].id = photo.id;

        event.list[event.index].imageLink = base;

        const photo = await this.eventService.createEventImg(that.event.name, that.event.place, event.list[event.index].imageLink);
        that.userService.removeEventPhoto(model.id, that.event.name, that.event.place);

        // event.list[event.index] = photo;

        event.list[event.index].id = photo.id;

        that.changeDetector.markForCheck();
        that.changeDetector.detectChanges();
      }
      loader.dismiss();
    };
    img.src = base64ImageSrc;
  }

  async deletePics(event: any) {
    console.log(event);

    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    await loader.present();
    const removed = await this.userService.removeEventPhoto(event.list[event.index].id, this.event.name, this.event.place);
    // const removed = await this.eventService.removePic(event.list[event.index]);
    this.event.images.splice(event.index, 1);
    this.initImages();

    loader.dismiss();

  }

  getRouteByIndex(route) {
    this.eventService.getEventRouteByIndex(this.event.id, this.event.cid, route.index).then(model => {
      (this.app.getRootNav() as NavController).push(EventDetailsMapPage, {
        event: this.event,
        route: model
      });
    });
  }

  uploadImage(data) {
    let loader = this.loadingCtrl.create({ content: 'loading' });
    loader.present();
    this.eventService.createEventImg(this.event.name, this.event.place, data).then(img => {
      this.filteredImages.push(img);
      this.event.images.push(img);
      loader.dismiss();
    });
  }

  openWebPage(url) {
    let browser = this.inAppBrowser.create(url, "_system", { hardwareback: 'yes' });
    browser.show();
  }

  fileInputClick() {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      correctOrientation: true
    };
    this.camera
      .getPicture(options)
      .then(photo => {
        this.uploadImage('data:image/jpeg;base64,' + photo);
      })
      .catch();
  }

  async createFileInput() {
    if (!(await this.config.config).platform.browser) return;
    if (document.querySelector('.cordova-camera-select')) return;
    try {
      const options: CameraOptions = {
        quality: 100,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        correctOrientation: true
      };
      this.camera
        .getPicture(options)
        .then(photo => {
          this.uploadImage('data:image/jpeg;base64,' + photo);
          this.createFileInput();
        })
        .catch(e => {
          console.log('catched exception : ');
          console.log(e);
        });
      var input = document.querySelector('.cordova-camera-select') as HTMLElement;
      document.body.removeChild(input);

      input.style.opacity = 0 + '';
      input.style.position = 'fixed';
      input.style.height = '3.7rem';
      input.style.width = '100%';

      let button = this.uploadButton.getNativeElement() as HTMLElement;
      button.parentElement.insertBefore(input, button);
    } catch { }
  }

  onResultsRedirect() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    if (this.clientHella) {
      this.eventService.getPage(`event/${GlobalUtil.getInstance().currentEventID}/raceresult/url`).then((res) => {
        if (!res) {
          this.app.getRootNav().getActiveChildNav().select(1);
          this.navCtrl.popToRoot();
        } else {
          let browser = this.inAppBrowser.create(res, "_system", { hardwareback: 'yes' });
          browser.show();
          // (  this.app.getRootNav() as NavController).push(InBrowserPage, { link: res });
        }
      });
    } else if (this.appDetector.isThurnauApp() || this.appDetector.isHannoverApp()) {
      (this.app.getRootNav() as NavController).popToRoot();
      this.app.getRootNav().getActiveChildNav().select(2);
    } else {
      (this.app.getRootNav() as NavController).popToRoot();
      this.app.getRootNav().getActiveChildNav().select(1);
    }

    loader.dismiss();
  }

  markEvent() {
    this.eventService.addToFavorit(this.event.id).then(succ => {
      if (succ) {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADDED_TOAST'),
            duration: 2000
          })
          .present();
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADD_FAILED_TOAST'),
            duration: 2000
          })
          .present();
      }
    });
  }

  reg() {
    this.eventService.addToRegistred(this.event.id).then(succ => {
      if (succ) {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADDED_TOAST'),
            duration: 2000
          })
          .present();
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('EVENT_ADD_FAILED_TOAST'),
            duration: 2000
          })
          .present();
      }
    });
  }

  dummyInitialize() {
    this.options.push("pünktlich");
    this.options.push("5 min später");
    this.options.push("10 min später");
    this.options.push("15 min später");
  }


  toastMessage(message, duration, position = "top") {
    this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position
    }).present();
  }
}


// WEBPACK FOOTER //
// /src/pages/event/details/event-details-shop/event-details-shop.ts